import { render } from "./CoffeeMugSVG.vue?vue&type=template&id=df7ec590"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__